const arr = [{
  path: 'list',
  name: 'list',
  component: resolve => {
    require(['../view/product/list.vue'], resolve)
  },
  meta:{
    keepAlive:true
  }
},
  {
    path: 'details/:id',
    name: 'details',
    component: resolve => {
      require(['../view/product/details.vue'], resolve)
    }
  },
  {
    path: 'pdf/:id',
    name: 'pdf',
    component: resolve => {
      require(['../view/product/pdf.vue'], resolve)
    }
  },
  {
    path: 'tgTeam',
    name: 'tgTeam',
    component: resolve => {
      require(['../view/product/tgTeam.vue'], resolve)
    }
  },
  {
    path: 'disclosureStatement',
    name: 'disclosureStatement',
    component: resolve => {
      require(['../view/product/disclosureStatement.vue'], resolve)
    }
  }]

export default arr;



// WEBPACK FOOTER //
// ./src/router/product.js